const NotFound = {
  name: 'not found',
  path: '*',
  element: <>Page Not Found</>,
}

export default [NotFound]
